<div class="custom-modal-wrap">
  <img class="img-icon" src="assets/images/popup_icon.png" *ngIf="!data.imageSrc">
  <img class="img-content" [src]="imageSrc" *ngIf="data.imageSrc">
  <div class="modal-title">{{data.title}}</div>
  <div class="modal-desc">{{data.content}}</div>
  <button *ngIf="!data.cancel" class="modal-btn" mat-button matDialogClose="confirm">확인</button>
  <div *ngIf="data.cancel" class="modal-btn-box">
    <button mat-button class="modal-btn modal-cancel-btn" matDialogClose="cancel">취소</button>
    <button mat-button class="modal-btn modal-ok-btn" matDialogClose="confirm">확인</button>
  </div>
</div>